module.exports = __webpack_public_path__ + "img/login-help-modal-icon.d55fc3b6.svg";